export const uid = {
    chat: "b1ede5af-bcce-4647-adb7-6cd5316dda74",
    help: "20cf2b5c-1863-4be2-a12d-5424f7a81fc8",
    contact: "76f5d859-d569-443d-aaec-85f1935ea8f6",
}
